import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  field: {
    margin: [theme.spacing(4), 0],
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/Search/useStyles.js